import {GET_FillBundleNo} from '../constants/ActionTypes'

const INIT_STATE = {
    BundleNo: null,
    //Message1: ''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillBundleNo:
                return {
                    BundleNo: action.body,
                    //Message1:action.msg
                  
                }
        default:
            return state;
    }
}